// extracted by mini-css-extract-plugin
export var actionText = "_mi-4";
export var container = "_mi-0";
export var leftSection = "_mi-1";
export var rightSection = "_mi-2";
export var settingsButton = "_mi-6";
export var settingsIcon = "_mi-7";
export var shortcut = "_mi-5";
export var shortcutGroup = "_mi-3";